import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";
import { Modal, Button } from 'react-bootstrap';
import * as Api from '../../../api/Api';
import { useQuery } from 'react-query';
import * as KeyNames from '../../../api/KeyNames';
import { ErrorConnection } from '../../../Components/Error/Error';
import { Loading } from '../../../Components/Loading/Loading';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { useGetToken } from '../../../Hooks/CustomHooks';

export default function RemoveRole({roleRemove,showRemoveRole,setShowRemoveRole, setRefreshData }) {
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    const [remove, setRemove] = useState(null);

    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm();

    const token = useGetToken();

    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionRespuesta, roleRemove],
        async () => await Api.removeRole({ role: roleRemove.id, token }),
        {
            enabled: Boolean(remove)
        });

    useEffect(() => {
        if (data) {
            if (data.success) {
                setFeedbackContext({ ...feedbackContext, showMessage: true, idMessage: 301 });
                setRemove(null);
                setRefreshData(true);
                setTimeout(window.location.reload(), 2000);
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
        }

    }, [data]);

    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)

    return (
        <Modal show={showRemoveRole} onHide={() => setShowRemoveRole(false)} aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header>
                <Modal.Title>Confirmación</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <span>Esta seguro que desea eliminar "{roleRemove.name}"</span>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secundary" onClick={() => setShowRemoveRole(false)}>No</Button>
                <Button variant="primary" onClick={() => { setRemove(true); setShowRemoveRole(false); }}>Si</Button>
            </Modal.Footer>
        </Modal>
    )
}